import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private contentCode$ = new BehaviorSubject<string>(null);

  private routeUrl: string;

  private viewCode: string;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateRouteUrl(event.url);
      });
  }

  /**
   * restituisce osservabile per i cambiamenti del content code
   */
  getContentCodeWhenChange(): Observable<string> {
    return this.contentCode$
      .asObservable()
      .pipe(debounceTime(5), distinctUntilChanged());
  }

  /**
   * imposta il nuovo url
   */
  updateRouteUrl(url: string): void {
    this.routeUrl = url;
    this.viewCode = '';
    this.notifyContentCode();
  }

  /**
   * imposta il nuovo view code
   */
  updateViewCode(code: string): void {
    this.viewCode = code;
    this.notifyContentCode();
  }

  /**
   * notifica il content code
   */
  private notifyContentCode(): void {
    let code = '';

    if (this.routeUrl) {
      code += this.routeUrl.split('/').join('_');
    }

    if (this.viewCode) {
      code += '_' + this.viewCode;
    }

    if (code.charAt(0) === '_') {
      code = code.substring(1);
    }

    this.contentCode$.next(code);
  }
}
